import React, {Fragment} from "react";
import {Grid} from "@material-ui/core";
import SelectField from "../../../lib/appfuse-react/component/SelectField";
import Form from "../../../lib/appfuse-react/component/Form";
import valueChange from "../../Judge/ValueChange";
import UserEvent from "../../../lib/appfuse-react/core/UserEvent";
import code from "../../../lib/appfuse-react/core/code";
import TextField from "../../../lib/appfuse-react/component/TextField";
import useResponsive from "../../../lib/appfuse-react/hook/useResponsive";

function BillInfo(props) {
    const {value={}, change={}, required, readOnly} = props;

    const variant = readOnly? 'standard':'outlined';
    const invoiceTypeOption = code.get('invoiceType');
    const invoiceTypeTwo = invoiceTypeOption.filter(item => item.value==='two');
    const invoiceTypeThree = invoiceTypeOption.filter(item => item.value==='three');
    const invoiceIdentityBool = valueChange.isEqual(value.invoiceIdentity, change.invoiceIdentity, 'personal');

    const handleChange = ({change:innerChange}) => {
        const newChange = {...change, ...innerChange};
        const newValue = {...value, ...innerChange};

        const {invoiceIdentity} = innerChange;
        if(invoiceIdentity==='personal' && invoiceIdentity!==change.invoiceIdentity) {
            newChange.invoiceTitle = valueChange.getEffectiveValue(value.chineseName, change.chineseName);
            newChange.invoiceType = 'two';
            newValue.invoiceTitle = newChange.invoiceTitle;
            newValue.invoiceType = 'two';
        } else if(invoiceIdentity==='company' && invoiceIdentity!==change.invoiceIdentity) {
            newChange.invoiceTitle = valueChange.getEffectiveValue(value.company, change.company);
            newChange.invoiceType = 'three';
            newValue.invoiceTitle = newChange.invoiceTitle;
            newValue.invoiceType = 'three';
        }

        props.onChange(new UserEvent({value:newValue, change:newChange}));
    };

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen()
    const xsResp = isMobile? 12:3;

    return (
        <Form value={value} change={change} onChange={handleChange} readOnly={readOnly}>
            <Grid container spacing={2} item xs={12}>
                <Grid item xs={12}>
                    <Grid container spacing={2}>
                        {/*身分*/}
                        <Grid item xs={xsResp}>
                            <SelectField name='invoiceIdentity' label='Identity' variant={variant} fullWidth code='invoiceIdentity' required={required}/>
                        </Grid>
                        {
                            valueChange.isEqual(value.invoiceIdentity, change.invoiceIdentity, 'company') && (
                                <Fragment>
                                    {/*公司名稱*/}
                                    <Grid item xs={xsResp}>
                                        <TextField name='company' label='Company' variant={variant} fullWidth required={required}/>
                                    </Grid>
                                    {/*部門*/}
                                    <Grid item xs={xsResp}>
                                        <TextField name='department' label='Department' variant={variant} fullWidth required={required}/>
                                    </Grid>
                                </Fragment>
                            )
                        }
                    </Grid>
                </Grid>

                {/*發票抬頭*/}
                <Grid item xs={xsResp}>
                    <TextField name='invoiceTitle' label='Invoice Title' variant={variant} fullWidth required={required}/>
                </Grid>
                {/*發票種類*/}
                <Grid item xs={xsResp}>
                    <SelectField name='invoiceType' label='Invoice Type' variant={variant} fullWidth options={invoiceIdentityBool? invoiceTypeTwo:invoiceTypeThree}
                                 required={required}/>
                </Grid>
                {
                    valueChange.isEqual(value.invoiceType, change.invoiceType, 'three') && (
                        <Grid item xs={xsResp}>
                            {/*統一編號*/}
                            <TextField name='taxIdNo' label='Tax Id No' variant={variant} fullWidth required={required}/>
                        </Grid>
                    )
                }
            </Grid>
        </Form>
    );
}

export default BillInfo;